var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35355 9.85355C5.54882 9.65829 5.54882 9.34171 5.35355 9.14645L1.20711 5L5.35355 0.853554C5.54882 0.658292 5.54882 0.341708 5.35355 0.146446C5.15829 -0.0488158 4.84171 -0.0488167 4.64645 0.146446L0.146447 4.64645C-0.0488153 4.84171 -0.0488153 5.15829 0.146447 5.35355L4.64645 9.85355C4.84171 10.0488 5.15829 10.0488 5.35355 9.85355Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.d6320e882a55872ab00c495624e67b28.svg";
export { ForwardRef as ReactComponent };